import { action } from 'typesafe-actions';
import { UserACL } from '../UserManagement/Types';
import {
	IAppsManagementActionTypes,
	IChannelSearchParams,
	Media,
} from './Types';

export const addGroupChannels = (channelIDs: number[], groupID: number) =>
	action(IAppsManagementActionTypes.ADD_GROUP_CHANNELS, [
		channelIDs,
		groupID,
	]);
export const addUserChannels = (channelIDs: number[], userID: number) =>
	action(IAppsManagementActionTypes.ADD_USER_CHANNELS, [channelIDs, userID]);

export const addGroupChannelsSTT = (channelIDs: number[], groupID: number) =>
	action(IAppsManagementActionTypes.ADD_GROUP_CHANNELS_STT, [
		channelIDs,
		groupID,
	]);
export const addGroupChannelsMT = (channelIDs: number[], groupID: number) =>
	action(IAppsManagementActionTypes.ADD_GROUP_CHANNELS_MT, [
		channelIDs,
		groupID,
	]);
export const addUserChannelsSTT = (channelIDs: number[], userID: number) =>
	action(IAppsManagementActionTypes.ADD_USER_CHANNELS_STT, [
		channelIDs,
		userID,
	]);
export const addGroupChannelsTPP = (channelIDs: number[], groupID: number) =>
	action(IAppsManagementActionTypes.ADD_GROUP_CHANNELS_TPP, [
		channelIDs,
		groupID,
	]);
export const addUserChannelsTPP = (channelIDs: number[], userID: number) =>
	action(IAppsManagementActionTypes.ADD_USER_CHANNELS_TPP, [
		channelIDs,
		userID,
	]);

export const getAllMedias = () =>
	action(IAppsManagementActionTypes.GET_ALL_MEDIAS);
export const getAllMediasFailed = (error: string) =>
	action(IAppsManagementActionTypes.GET_ALL_MEDIAS_FAILED, error);
export const getAllMediasSucceed = (mediasList: Media[]) =>
	action(IAppsManagementActionTypes.GET_ALL_MEDIAS_SUCCEED, mediasList);

export const getChannelsFromUser = (userID: number, group: boolean) =>
	action(IAppsManagementActionTypes.GET_CHANNELS_FROM_USER, [userID, group]);
export const getChannelsFromUserFailed = (error: string) =>
	action(IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_FAILED, error);
export const getChannelsFromUserSucceed = (channelsList: Media[]) =>
	action(
		IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_SUCCEED,
		channelsList
	);
export const getChannelsFromUserMT = (userID: number, token: string) =>
	action(IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_MT, [
		userID,
		token,
	]);
export const getChannelsFromUserMTFailed = (error: string) =>
	action(IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_MT_FAILED, error);
export const getChannelsFromUserMTSucceed = (channelsList: Media[]) =>
	action(
		IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_MT_SUCCEED,
		channelsList
	);
export const getChannelsFromUserSTT = (userID: number, group: boolean) =>
	action(IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_STT, [
		userID,
		group,
	]);
export const getChannelsFromUserSTTFailed = (error: string) =>
	action(IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_STT_FAILED, error);
export const getChannelsFromUserSTTSucceed = (channelsList: Media[]) =>
	action(
		IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_STT_SUCCEED,
		channelsList
	);
export const getChannelsFromUserTPP = (userID: number, group: boolean) =>
	action(IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_TPP, [
		userID,
		group,
	]);
export const getChannelsFromUserTPPFailed = (error: string) =>
	action(IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_TPP_FAILED, error);
export const getChannelsFromUserTPPSucceed = (channelsList: Media[]) =>
	action(
		IAppsManagementActionTypes.GET_CHANNELS_FROM_USER_TPP_SUCCEED,
		channelsList
	);

export const getMedia = (mediaNumber: number) =>
	action(IAppsManagementActionTypes.GET_MEDIA, mediaNumber);
export const getMediaFailed = (error: string) =>
	action(IAppsManagementActionTypes.GET_MEDIA_FAILED, error);
export const getMediaSucceed = (media: Media) =>
	action(IAppsManagementActionTypes.GET_MEDIA_SUCCEED, media);

export const getGroupsAndUsersFromChannel = (
	mediaNumber: number,
	token: string
) =>
	action(IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL, [
		mediaNumber,
		token,
	]);
export const getGroupsAndUsersFromChannelFailed = (error: string) =>
	action(
		IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_FAILED,
		error
	);
export const getGroupsAndUsersFromChannelSucceed = (
	users: UserACL[],
	groups: UserACL[]
) =>
	action(
		IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_SUCCEED,
		[users, groups]
	);
export const getGroupsFromChannelMT = (mediaNumber: number, token: string) =>
	action(IAppsManagementActionTypes.GET_GROUPS_FROM_CHANNEL_MT, [
		mediaNumber,
		token,
	]);
export const getGroupsFromChannelMTFailed = (error: string) =>
	action(IAppsManagementActionTypes.GET_GROUPS_FROM_CHANNEL_MT_FAILED, error);
export const getGroupsFromChannelMTSucceed = (
	users: UserACL[],
	groups: UserACL[]
) =>
	action(IAppsManagementActionTypes.GET_GROUPS_FROM_CHANNEL_MT_SUCCEED, [
		users,
		groups,
	]);
export const getGroupsAndUsersFromChannelSTT = (
	mediaNumber: number,
	token: string
) =>
	action(IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_STT, [
		mediaNumber,
		token,
	]);
export const getGroupsAndUsersFromChannelSTTFailed = (error: string) =>
	action(
		IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_STT_FAILED,
		error
	);
export const getGroupsAndUsersFromChannelSTTSucceed = (
	users: UserACL[],
	groups: UserACL[]
) =>
	action(
		IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_STT_SUCCEED,
		[users, groups]
	);
export const getGroupsAndUsersFromChannelTPP = (
	mediaNumber: number,
	token: string
) =>
	action(IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_TPP, [
		mediaNumber,
		token,
	]);
export const getGroupsAndUsersFromChannelTPPFailed = (error: string) =>
	action(
		IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_TPP_FAILED,
		error
	);
export const getGroupsAndUsersFromChannelTPPSucceed = (
	users: UserACL[],
	groups: UserACL[]
) =>
	action(
		IAppsManagementActionTypes.GET_GROUPS_AND_USERS_FROM_CHANNEL_TPP_SUCCEED,
		[users, groups]
	);

export const resetMedias = () =>
	action(IAppsManagementActionTypes.RESET_MEDIAS);

export const setAllChannelsFilter = (filter: IChannelSearchParams) =>
	action(IAppsManagementActionTypes.SET_ALL_CHANNELS_FILTER, filter);

export const setGroupChannels = (channelIDs: number[], groupID: number) =>
	action(IAppsManagementActionTypes.SET_GROUP_CHANNELS, [
		channelIDs,
		groupID,
	]);
export const setGroupChannelsMT = (
	addedIDs: { mediaID: number; startDate: string; endDate: string }[],
	removedIDs: { mediaID: number; startDate: string; endDate: string }[],
	updatedIDs: { mediaID: number; startDate: string; endDate: string }[],
	userID: number,
	token: string
) =>
	action(IAppsManagementActionTypes.SET_USER_CHANNELS_MT, [
		addedIDs,
		removedIDs,
		updatedIDs,
		userID,
		token,
	]);
export const setGroupChannelsSTT = (channelIDs: number[], groupID: number) =>
	action(IAppsManagementActionTypes.SET_GROUP_CHANNELS_STT, [
		channelIDs,
		groupID,
	]);
export const setGroupChannelsTPP = (channelIDs: number[], groupID: number) =>
	action(IAppsManagementActionTypes.SET_GROUP_CHANNELS_TPP, [
		channelIDs,
		groupID,
	]);

export const setLoadingChannelsFromUser = (bool: boolean) =>
	action(IAppsManagementActionTypes.SET_LOADING_CHANNELS_FROM_USER, bool);

export const setLoadingGroupsAndUsersFromChannel = (bool: boolean) =>
	action(
		IAppsManagementActionTypes.SET_LOADING_GROUPS_AND_USERS_FROM_CHANNEL,
		bool
	);

export const setLoadingMedias = (bool: boolean) =>
	action(IAppsManagementActionTypes.SET_LOADING_MEDIAS, bool);
export const setUserChannels = (channelsID: number[], id: number) =>
	action(IAppsManagementActionTypes.SET_USER_CHANNELS, [channelsID, id]);

export const setUserChannelsSTT = (channelsID: number[], id: number) =>
	action(IAppsManagementActionTypes.SET_USER_CHANNELS_STT, [channelsID, id]);
export const setUserChannelsTPP = (channelsID: number[], id: number) =>
	action(IAppsManagementActionTypes.SET_USER_CHANNELS_TPP, [channelsID, id]);

export const setUserChannelsSucceed = () =>
	action(IAppsManagementActionTypes.SET_USER_CHANNELS_SUCCEED);

export const setUserChannelsFailed = (error: string) =>
	action(IAppsManagementActionTypes.SET_USER_CHANNELS_FAILED, error);

export const setUserChannelsSTTSucceed = () =>
	action(IAppsManagementActionTypes.SET_USER_CHANNELS_STT_SUCCEED);

export const setUserChannelsSTTFailed = (error: string) =>
	action(IAppsManagementActionTypes.SET_USER_CHANNELS_STT_FAILED, error);

export const setUserChannelsTPPSucceed = () =>
	action(IAppsManagementActionTypes.SET_USER_CHANNELS_TPP_SUCCEED);

export const setUserChannelsTPPFailed = (error: string) =>
	action(IAppsManagementActionTypes.SET_USER_CHANNELS_TPP_FAILED, error);
